import { Navigate } from 'react-router-dom';
import { ReactNode } from 'react';

import { useFeatureRequestAccess } from '@/features/feature-requests/hooks/use-feature-requests';
import type { FeatureRequestAccess } from '@/features/feature-requests/services/feature-requests-service';

interface FeatureRequestRouteProps {
  children: ReactNode;
  /** my-access flag the route needs (the developer board needs `can_manage`). */
  requires: keyof FeatureRequestAccess;
}

/**
 * Route guard for the feature request screens. Rendering only: the backend
 * re-checks `feature_requests:*` on every request.
 */
export function FeatureRequestRoute({ children, requires }: FeatureRequestRouteProps) {
  const { data, isLoading, isError } = useFeatureRequestAccess();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }
  if (isError || !data?.[requires]) {
    return <Navigate to="/home" replace />;
  }
  return <>{children}</>;
}
